<section class="flow-diagram" [attr.aria-label]="heading">
    <div class="diagram-header">
        <h3 class="diagram-title">{{ heading }}</h3>
        <button
            type="button"
            class="diagram-toggle"
            [attr.aria-expanded]="!collapsed"
            [attr.aria-controls]="collapsed ? null : bodyId"
            [attr.aria-label]="collapsed ? 'Show diagram' : 'Hide diagram'"
            (click)="toggle()"
        >
            <i class="pi" [class.pi-chevron-down]="collapsed" [class.pi-chevron-up]="!collapsed" aria-hidden="true"></i>
        </button>
    </div>

    @if (!collapsed) {
    <!-- Every item is placed by --start and --span, so the stacked layout only swaps columns for rows. -->
    <div
        class="diagram-flow {{ sizeClass }}"
        [class.has-zones]="layout.bands.length > 0"
        [id]="bodyId"
        [style.--columns]="layout.columns"
        [style.--rows]="layout.rows"
    >
        @for (band of layout.bands; track band.start) {
        <div
            class="flow-zone zone-{{ band.zone }}"
            [class.zone-divider]="band.start !== 1"
            [style.--start]="band.start"
            [style.--span]="band.span"
        >
            <span class="flow-zone-label">{{ band.label }}</span>
        </div>
        } @for (node of nodes; track $index; let i = $index) { @if (layout.nodes[i]) {
        <div
            class="flow-node node-{{ node.tone }}"
            [style.--start]="layout.nodes[i].start"
            [style.--span]="layout.nodes[i].span"
        >
            <div class="flow-node-stripe"></div>
            <div class="flow-node-title">{{ node.title }}</div>
            @if (node.desc) {
            <div class="flow-node-desc">{{ node.desc }}</div>
            } @if (node.rows?.length) {
            <div class="flow-node-data">
                @for (row of node.rows; track row.label) {
                <div class="flow-node-data-row">
                    <span class="flow-node-data-label">{{ row.label }}</span>
                    <span class="flow-node-data-value">{{ row.value }}</span>
                </div>
                }
            </div>
            }
        </div>
        } } @for (link of links; track $index; let i = $index) { @if (link && layout.links[i]) {
        <div class="flow-connection" [style.--start]="layout.links[i].start" [style.--span]="layout.links[i].span">
            <div class="flow-connection-label">{{ link.label }}</div>
            <div class="flow-connection-arrow" aria-hidden="true">
                <span class="line"></span>
                <span class="head head-right"></span>
                <span class="head head-left"></span>
            </div>
            @if (link.sub) {
            <div class="flow-connection-sub">{{ link.sub }}</div>
            }
        </div>
        } }
    </div>
    }
</section>
